import { Customer } from '../../domain/types';
import { CrudHandler } from '../CrudHandler';
import { apiPaths } from '../../utils/apiPaths';
import { mockCustomerData } from '../data/adminData';

export const customersHandler = new CrudHandler<Customer>(
  apiPaths.customer.base,
  mockCustomerData
);
